import styled from 'styled-components';

import colors from '../../../../../styles/colors';
import Select from '../../../../../components/v2/Select';
import { TOGGLE_BAR_HEIGHT } from '../Announcements/styles';

const Rail = styled.div`
  position: sticky;
  top: ${TOGGLE_BAR_HEIGHT}px;
  align-self: flex-start;
  width: 240px;
  flex-shrink: 0;
  padding: 20px;
  border-right: 1px solid ${colors.shades.gamma13};
  background-color: ${colors.base.alpha};
`;

const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${colors.shades.gamma10};
  margin-bottom: 9px;
`;

const RowList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const Row = styled.button`
  display: flex;
  border: none;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  text-wrap: nowrap;
  background-color: ${({ $active }) => ($active ? colors.base.secondary2 : 'transparent')};
  color: ${({ $active }) => ($active ? colors.base.alpha : colors.shades.gamma14)};
`;

const Dropdown = styled(Select)`
  width: 100%;
  margin-bottom: 20px;
`;

const ToggleSection = styled.div`
  margin-bottom: 20px;
`;

export {
  Rail,
  SectionLabel,
  RowList,
  Row,
  Dropdown,
  ToggleSection,
};
